import script from "./TitlePreviewDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./TitlePreviewDrawer.vue?vue&type=script&setup=true&lang=js"

import "./TitlePreviewDrawer.vue?vue&type=style&index=0&id=b7e6d996&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7e6d996"]])

export default __exports__